import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import { BRAND_TYPE } from "@faire/help-center-utils/consts/BRAND_TYPE";
import { OTHER_TYPE } from "@faire/help-center-utils/consts/OTHER_TYPE";
import { RETAILER_TYPE } from "@faire/help-center-utils/consts/RETAILER_TYPE";
export var CUSTOMER_TYPE_PROMPT_MESSAGE = function CUSTOMER_TYPE_PROMPT_MESSAGE(strictLocalize) {
  return strictLocalize({
    id: "489f45",
    defaultMessage: [{
      "type": 0,
      "value": "É revendedor ou marca?"
    }]
  });
};
export var EMAIL_PROMPT_MESSAGE = function EMAIL_PROMPT_MESSAGE(strictLocalize) {
  return strictLocalize({
    id: "2tD3qu",
    defaultMessage: [{
      "type": 0,
      "value": "E-mail de contacto"
    }]
  });
};
export var BUSINESS_NAME_PROMPT_MESSAGE = function BUSINESS_NAME_PROMPT_MESSAGE(strictLocalize) {
  return strictLocalize({
    id: "mnBd4h",
    defaultMessage: [{
      "type": 0,
      "value": "Nome da empresa"
    }]
  });
};
export var TICKET_DETAIL_PROMPT_MESSAGE = function TICKET_DETAIL_PROMPT_MESSAGE(strictLocalize) {
  return strictLocalize({
    id: "dvom6Q",
    defaultMessage: [{
      "type": 0,
      "value": "Por favor, descreva a sua pergunta em detalhe"
    }]
  });
};
var RETAILER_TYPE_LABEL = function RETAILER_TYPE_LABEL(strictLocalize) {
  return strictLocalize({
    id: "BFIfFM",
    defaultMessage: [{
      "type": 0,
      "value": "Sou um revendedor"
    }]
  });
};
var BRAND_TYPE_LABEL = function BRAND_TYPE_LABEL(strictLocalize) {
  return strictLocalize({
    id: "KL8KgJ",
    defaultMessage: [{
      "type": 0,
      "value": "Sou uma marca"
    }]
  });
};
var OTHER_TYPE_LABEL = function OTHER_TYPE_LABEL(strictLocalize) {
  return strictLocalize({
    id: "pTuCf6",
    defaultMessage: [{
      "type": 0,
      "value": "Outro"
    }]
  });
};
var CUSTOMER_TYPE_LIST = function CUSTOMER_TYPE_LIST(strictLocalize) {
  return [{
    value: RETAILER_TYPE,
    label: RETAILER_TYPE_LABEL(strictLocalize)
  }, {
    value: BRAND_TYPE,
    label: BRAND_TYPE_LABEL(strictLocalize)
  }];
};
var INCLUSIVE_CUSTOMER_TYPE_LIST = function INCLUSIVE_CUSTOMER_TYPE_LIST(strictLocalize) {
  return [].concat(_toConsumableArray(CUSTOMER_TYPE_LIST(strictLocalize)), [{
    value: OTHER_TYPE,
    label: OTHER_TYPE_LABEL(strictLocalize)
  }]);
};
export var getCustomerTypeList = function getCustomerTypeList(strictLocalize) {
  return INCLUSIVE_CUSTOMER_TYPE_LIST(strictLocalize);
};